const Actions = {
  setData: data => ({
    type: 'PAGE:SET_DATA',
    payload: data
  })
};

export default Actions;
